import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHero } from "@/components/PageHero";
import { HolidayCard } from "@/components/HolidayCard";
import { Loader2 } from "lucide-react";

const cats = ["All", "Beach", "Luxury", "City"];

export default function Holidays() {
  const [params] = useSearchParams();
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cat, setCat] = useState("All");

  useEffect(() => {
    setLoading(true);
    const q = {};
    if (params.get("destination")) q.destination = params.get("destination");
    api.get("/holidays", { params: q }).then(({ data }) => setHolidays(data)).finally(() => setLoading(false));
  }, [params]);

  const shown = cat === "All" ? holidays : holidays.filter((h) => h.category === cat);

  return (
    <div>
      <PageHero title="Holiday packages" subtitle="Flight + hotel bundles with unbeatable value, fully protected." image="https://images.unsplash.com/photo-1561501900-3701fa6a0864" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex flex-wrap gap-2 mb-6">
          {cats.map((c) => (
            <button key={c} data-testid={`holiday-cat-${c.toLowerCase()}`} onClick={() => setCat(c)}
              className={`px-4 py-1.5 rounded-full text-sm font-semibold transition-colors ${cat === c ? "bg-[#0B3C5D] text-white" : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-100"}`}>{c}</button>
          ))}
        </div>
        {loading ? <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-[#0B3C5D]" /></div> : (
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">{shown.map((h) => <HolidayCard key={h.id} h={h} />)}</div>
        )}
        {!loading && shown.length === 0 && <p className="text-center text-slate-500 py-20">No packages found.</p>}
      </div>
    </div>
  );
}
